import mapboxgl from './mapboxgl';
var setRTLTextPlugin = mapboxgl ? mapboxgl.setRTLTextPlugin : function () {};
export default setRTLTextPlugin;